import React from 'react';
import { Transition } from '@headlessui/react';
import PropTypes from 'prop-types';

export default function Notification({ notification, closeNotification }) {
  return (
    <Transition
      show={notification.show}
      enter="transition ease-out duration-300"
      enterFrom="opacity-0"
      enterTo="opacity-100"
      leave="transition ease-in duration-300"
      leaveFrom="opacity-100"
      leaveTo="opacity-0"
    >
      <div
        className="fixed top-3 right-3 m-3 w-2/3 md:w-1/3 z-30"
        id="go-cms__notification"
      >
        <div className="bg-white border-gray-300 border p-3 flex items-start shadow-lg rounded-md space-x-2">
          {!notification.error ? (
            <svg
              className="flex-shrink-0 h-6 w-6 text-green-400"
              stroke="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                strokeWidth="1"
                d="M10.219,1.688c-4.471,0-8.094,3.623-8.094,8.094s3.623,8.094,8.094,8.094s8.094-3.623,8.094-8.094S14.689,1.688,10.219,1.688 M10.219,17.022c-3.994,0-7.242-3.247-7.242-7.241c0-3.994,3.248-7.242,7.242-7.242c3.994,0,7.241,3.248,7.241,7.242C17.46,13.775,14.213,17.022,10.219,17.022 M15.099,7.03c-0.167-0.167-0.438-0.167-0.604,0.002L9.062,12.48l-2.269-2.277c-0.166-0.167-0.437-0.167-0.603,0c-0.166,0.166-0.168,0.437-0.002,0.603l2.573,2.578c0.079,0.08,0.188,0.125,0.3,0.125s0.222-0.045,0.303-0.125l5.736-5.751C15.268,7.466,15.265,7.196,15.099,7.03"
              ></path>
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="flex-shrink-0 h-6 w-6 text-red-400"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          )}
          <div className="flex-1 space-y-1">
            <p className="text-base leading-6 font-medium text-gray-700">
              {notification.title}
            </p>
            <p className="text-sm leading-5 text-gray-600">
              {notification.message}
            </p>
          </div>
          <svg
            className="flex-shrink-0 h-5 w-5 text-gray-400 cursor-pointer"
            stroke="currentColor"
            viewBox="0 0 20 20"
            onClick={closeNotification}
          >
            <path
              strokeWidth="1.2"
              d="M15.898,4.045c-0.271-0.272-0.713-0.272-0.986,0l-4.71,4.711L5.493,4.045c-0.272-0.272-0.714-0.272-0.986,0s-0.272,0.714,0,0.986l4.709,4.711l-4.71,4.711c-0.272,0.271-0.272,0.713,0,0.986c0.136,0.136,0.314,0.203,0.492,0.203c0.179,0,0.357-0.067,0.493-0.203l4.711-4.711l4.71,4.711c0.137,0.136,0.314,0.203,0.494,0.203c0.178,0,0.355-0.067,0.492-0.203c0.273-0.273,0.273-0.715,0-0.986l-4.711-4.711l4.711-4.711C16.172,4.759,16.172,4.317,15.898,4.045z"
            ></path>
          </svg>
        </div>
      </div>
    </Transition>
  );
}

Notification.propTypes = {
  notification: PropTypes.object.isRequired,
  closeNotification: PropTypes.func.isRequired
};
